module.exports = __webpack_public_path__ + "static/media/jump.5d46595d.png";